// import { useEffect, useState } from 'react'
// // import Icons from '../../../components/common/icons'
// import Navigator from '../../../components/common/Navigator'
// import { Button } from '../../../components/common'
// import { useActsRules } from '../api'
// import DOMPurify from 'dompurify'

// const ActsAndRules = () => {
//   const { data, isLoading, isError } = useActsRules()
//   const acts = data?.data || []

//   const [selectedAct, setSelectedAct] = useState<any>(null)
//   useEffect(() => {
//     if (selectedAct) {
//       document.body.style.overflow = 'hidden'
//     } else {
//       document.body.style.overflow = 'auto'
//     }
//     return () => {
//       document.body.style.overflow = 'auto'
//     }
//   }, [selectedAct])

//   if (isLoading) {
//     return (
//       <section className="py-12 px-4">
//         <p>Loading Acts and Rules...</p>
//       </section>
//     )
//   }

//   if (isError) {
//     return (
//       <section className="py-12 px-4">
//         <p>Error loading Acts and Rules</p>
//       </section>
//     )
//   }
//   const capitalizeFirstLetter = (text: string) =>
//     text ? text.charAt(0).toUpperCase() + text.slice(1) : ''
//   // const capitalizeHTMLText = (html: string) => {
//   //   if (!html) return ''

//   //   const parser = new DOMParser()
//   //   const doc = parser.parseFromString(html, 'text/html')

//   //   const capitalizeNode = (node: ChildNode) => {
//   //     if (node.nodeType === Node.TEXT_NODE) {
//   //       const text = node.textContent || '' // ensure string
//   //       node.textContent = text.replace(/^\s*\w/, (c) => c.toUpperCase())
//   //     } else if (node.childNodes.length > 0) {
//   //       node.childNodes.forEach(capitalizeNode)
//   //     }
//   //   }

//   //   doc.body.childNodes.forEach(capitalizeNode)
//   //   return doc.body.innerHTML
//   // }
//   const capitalizeHTMLText = (html: string) => {
//     if (!html) return ''

//     const parser = new DOMParser()
//     const doc = parser.parseFromString(html, 'text/html')

//     const capitalizeNode = (node: ChildNode) => {
//       if (node.nodeType === Node.TEXT_NODE) {
//         const text = node.textContent || ''
//         node.textContent = text.replace(/^\s*\w/, (c) => c.toUpperCase())
//       } else if (node.childNodes.length > 0) {
//         node.childNodes.forEach(capitalizeNode)
//       }
//     }

//     doc.body.childNodes.forEach(capitalizeNode)
//     return doc.body.innerHTML
//   }

//   return (
//     <div className="lg:w-11/12 mx-auto p-4 lg:p-0 bg-white py-10">
//       <Navigator
//         title="Acts, Rules and Government Orders (GO)"
//         slug="ACTS_AND_RULES"
//       />

//       <span className="font-barlow font-medium text-4xl leading-[40px] text-black">
//         Acts, Rules and Government Orders (GO)
//       </span>

//       <hr className="border-t-2 border-primaryBlue mb-6 mt-3" />

//       <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 px-3 mb-5">
//         {acts.map((act: any) => (

//           <div
//             key={act.id}
//             className="border border-gray-200 rounded-lg p-5 shadow-sm flex flex-col justify-between w-full h-[320px]"
//           >
//             <div>
//               <div className="flex items-center justify-between mb-3">
//                 <span className="text-PrimaryGray lg:text-[14px] md:text-[11px] xs:text-[12px] font-barlow font-[600]">
//                   Posted On:{' '}
//                   {new Date(act?.created_at).toLocaleDateString('en-GB', {
//                     day: '2-digit',
//                     month: 'short',
//                     year: 'numeric',
//                   })}
//                 </span>
//                 {/* <div className="flex items-center gap-1 bg-gray-50 text-black px-2 py-1 rounded-full text-xs">
//                   <Icons name="watch" className="text-black" />
//                   <p className="font-barlow font-normal lg:text-[12px] text-[9px] leading-[28px] text-black">
//                     {act?.readTime}
//                   </p>
//                 </div> */}
//               </div>

//               {/* <div className="font-barlow font-[600] text-[22px] leading-[27px] text-black mb-2">
//                 {act?.title}
//               </div> */}
//               <div className="font-barlow font-[600] text-[22px] leading-[27px] text-black mb-2">
//                 {capitalizeFirstLetter(act?.title || '')}
//               </div>

//               {/* <p
//                 className="font-barlow bg-white text-[14px]  text-black mb-2 line-clamp-4 text-justify"
//                 dangerouslySetInnerHTML= {{
//                   __html: DOMPurify.sanitize(act?.description, {
//                     FORBID_ATTR: ['style'],
//                   }),
//                 }}
//               /> */}
//               <p
//                 className="font-barlow bg-white text-[14px] text-black mb-2 line-clamp-4 text-justify"
//                 dangerouslySetInnerHTML={{
//                   __html: DOMPurify.sanitize(
//                     capitalizeHTMLText(act?.description || ''),
//                     {
//                       FORBID_ATTR: ['style'],
//                     }
//                   ),
//                 }}
//               />
//             </div>

//             <div className="mt-4">
//               <Button
//                 label="View More"
//                 size="common"
//                 outlined
//                 className="border border-PrimaryOrange text-PrimaryOrange rounded-sm px-10 py-4 hover:bg-PrimaryOrange hover:text-white w-full text-[20px]"
//                 onClick={() => setSelectedAct(act)}
//               />
//             </div>
//           </div>
//         ))}
//       </div>

//       {selectedAct && (
//         <div className="fixed inset-0 bg-black/60 backdrop-blur-[2px] flex items-center justify-center z-50 p-4">
//           <div className="bg-white rounded-lg shadow-lg max-w-6xl w-full p-6 relative max-h-[90vh] overflow-y-auto">
//             <div className="flex items-center justify-between mb-4">
//               <div className="flex flex-col items-start">
//                 <span className="text-gray-900">
//                   Posted On:
//                   {new Date(selectedAct?.created_at).toLocaleDateString(
//                     'en-GB',
//                     {
//                       day: '2-digit',
//                       month: 'short',
//                       year: 'numeric',
//                     }
//                   )}
//                 </span>
//               </div>
//             </div>

//             {/* <h2 className="text-2xl font-bold mb-3">{capitalizeFirstLetter(selectedAct?.title)}</h2>
//             <div
//               className="text-[15px] leading-7 text-gray-900 text-black bg-white"
//               dangerouslySetInnerHTML={{
//                 __html: selectedAct?.description || '',
//               }}
//             /> */}
//             {/* <h2 className="text-2xl font-bold mb-3">
//   {capitalizeFirstLetter(selectedAct?.title)}
// </h2> */}
//             <h2 className="text-2xl font-bold mb-3">
//               {capitalizeFirstLetter(selectedAct?.title)}
//             </h2>

//             <div
//               className="font-barlow bg-white text-[14px] text-black text-justify"
//               dangerouslySetInnerHTML={{
//                 __html: DOMPurify.sanitize(
//                   capitalizeHTMLText(selectedAct?.description || '')
//                     .replace(
//                       /<ul>/g,
//                       `<ul style="list-style-type: disc; padding-left: 1.25rem; margin-bottom: 0.5rem;">`
//                     )
//                     .replace(
//                       /<ol>/g,
//                       `<ol style="list-style-type: decimal; padding-left: 1.25rem; margin-bottom: 0.5rem;">`
//                     )
//                     .replace(/<li>/g, `<li style="margin-bottom: 0.25rem;">`),
//                   {
//                     ALLOWED_TAGS: [
//                       'p',
//                       'span',
//                       'strong',
//                       'em',
//                       'ul',
//                       'ol',
//                       'li',
//                       'br',
//                     ],
//                     ALLOWED_ATTR: ['class', 'href'], // keep safe attributes
//                   }
//                 ),
//               }}
//             />

//             {/* <div
//               className="font-barlow bg-white text-[14px] text-black text-justify"
//               dangerouslySetInnerHTML={{
//                 __html: DOMPurify.sanitize(
//                   capitalizeHTMLText(selectedAct?.description || ''),
//                   {
//                     FORBID_ATTR: ['style'], // remove inline styles if needed
//                   }
//                 ),
//               }}
//             />
//  */}
//             <div className="mt-4 flex justify-center gap-4">
//               <Button
//                 outlined
//                 label="Visit"
//                 className="border border-PrimaryOrange text-PrimaryOrange rounded-sm px-10 hover:bg-PrimaryOrange hover:text-white min-w-[160px] text-[20px] align-middle"
//                 onClick={() => {
//                   let url = selectedAct?.link

//                   if (url) {
//                     url = url.replace(/\\\//g, '/')

//                     url = url.replace(/^https?\/\//, (match: any) =>
//                       match.replace('//', '://')
//                     )

//                     if (!/^https?:\/\//i.test(url)) {
//                       url = 'https://' + url
//                     }

//                     window.open(url, '_blank', 'noopener,noreferrer')
//                   }
//                 }}
//               />
//               <Button
//                 label="Close"
//                 redOutlined
//                 className="min-w-[160px] px-10"
//                 onClick={() => setSelectedAct(null)}
//               />
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   )
// }

// export default ActsAndRules

import { useEffect, useState } from 'react'
import Navigator from '../../../components/common/Navigator'
import { Button } from '../../../components/common'
import { useActsRules } from '../api'
import DOMPurify from 'dompurify'

const ActsAndRules = () => {
  const { data, isLoading, isError } = useActsRules()
  const acts = data?.data || []

  const [selectedAct, setSelectedAct] = useState<any>(null)

  useEffect(() => {
    document.body.style.overflow = selectedAct ? 'hidden' : 'auto'
    return () => {
      document.body.style.overflow = 'auto'
    }
  }, [selectedAct])

  if (isLoading)
    return (
      <section className="py-12 px-4">
        <p>Loading Acts and Rules...</p>
      </section>
    )

  if (isError)
    return (
      <section className="py-12 px-4">
        <p>Error loading Acts and Rules</p>
      </section>
    )

  const capitalizeFirstLetter = (text: string) =>
    text ? text.charAt(0).toUpperCase() + text.slice(1) : ''

  const stripHtmlTags = (htmlString: string) => {
    const doc = new DOMParser().parseFromString(htmlString, 'text/html')
    return doc.body.textContent?.trim() || ''
  }

  const capitalizeHTMLText = (html: string) => {
    if (!html) return ''
    const parser = new DOMParser()
    const doc = parser.parseFromString(html, 'text/html')

    const capitalizeNode = (node: ChildNode) => {
      if (node.nodeType === Node.TEXT_NODE) {
        const text = node.textContent || ''
        node.textContent = text.replace(/^\s*\w/, (c) => c.toUpperCase())
      } else if (node.childNodes.length > 0) {
        node.childNodes.forEach(capitalizeNode)
      }
    }

    doc.body.childNodes.forEach(capitalizeNode)
    return doc.body.innerHTML
  }

  return (
    <div className="lg:w-11/12 mx-auto p-4 lg:p-0 bg-white lg:my-8 py-10">
      <Navigator
        title="Acts, Rules and Government Orders (GO)"
        slug="ACTS_AND_RULES"
      />

      <span className="font-barlow font-medium text-4xl leading-[40px] text-black">
        Acts, Rules and Government Orders (GO)
      </span>

      <hr className="border-t-2 border-primaryBlue mb-6 mt-3" />

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 px-3 mb-5">
        {acts.map((act: any) => {
          const textOnly = stripHtmlTags(act?.description || '')
          const showViewMore = textOnly.length > 200

          return (
            <div
              key={act.id}
              className="border border-gray-200 rounded-lg p-5 shadow-sm flex flex-col justify-between w-full h-[320px]"
            >
              <div>
                <div className="flex items-center justify-between mb-3">
                  <span className="text-PrimaryGray lg:text-[14px] md:text-[11px] xs:text-[12px] font-barlow font-[600]">
                    Posted On:{' '}
                    {new Date(act?.created_at).toLocaleDateString('en-GB', {
                      day: '2-digit',
                      month: 'short',
                      year: 'numeric',
                    })}
                  </span>
                </div>

                <div className="font-barlow font-[600] text-[22px] leading-[27px] text-black mb-2">
                  {capitalizeFirstLetter(act?.title || '')}
                </div>

                <p
                  className="font-barlow bg-white text-[14px] text-black mb-2 line-clamp-4 text-justify"
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(
                      capitalizeHTMLText(act?.description || ''),
                      {
                        FORBID_ATTR: ['style'],
                      }
                    ),
                  }}
                />
              </div>

              {showViewMore && (
                <div className="mt-4">
                  <Button
                    label="View More"
                    size="common"
                    outlined
                    className="border border-PrimaryOrange text-PrimaryOrange rounded-sm px-10 py-4 hover:bg-PrimaryOrange hover:text-white w-full text-[20px]"
                    onClick={() => setSelectedAct(act)}
                  />
                </div>
              )}
            </div>
          )
        })}
      </div>

      {selectedAct && (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-[2px] flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg shadow-lg max-w-6xl w-full p-6 relative max-h-[90vh] overflow-y-auto">
            <div className="flex items-center justify-between mb-4">
              <span className="text-gray-900">
                Posted On:{' '}
                {new Date(selectedAct?.created_at).toLocaleDateString('en-GB', {
                  day: '2-digit',
                  month: 'short',
                  year: 'numeric',
                })}
              </span>
            </div>

            <h2 className="text-2xl font-bold mb-3">
              {capitalizeFirstLetter(selectedAct?.title)}
            </h2>

            <div
              className="font-barlow bg-white text-[14px] text-black text-justify"
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(
                  capitalizeHTMLText(selectedAct?.description || '')
                    .replace(
                      /<ul>/g,
                      `<ul style="list-style-type: disc; padding-left: 1.25rem; margin-bottom: 0.5rem;">`
                    )
                    .replace(
                      /<ol>/g,
                      `<ol style="list-style-type: decimal; padding-left: 1.25rem; margin-bottom: 0.5rem;">`
                    )
                    .replace(/<li>/g, `<li style="margin-bottom: 0.25rem;">`),
                  {
                    ALLOWED_TAGS: [
                      'p',
                      'span',
                      'strong',
                      'em',
                      'ul',
                      'ol',
                      'li',
                      'br',
                    ],
                    ALLOWED_ATTR: ['class', 'href', 'style'],
                  }
                ),
              }}
            />

            <div className="mt-4 flex justify-center gap-4">
              {selectedAct?.link && (
                <Button
                  outlined
                  label="Visit"
                  className="border border-PrimaryOrange text-PrimaryOrange rounded-sm px-10 hover:bg-PrimaryOrange hover:text-white min-w-[160px] text-[20px] align-middle"
                  onClick={() => {
                    let url = selectedAct?.link
                    if (!/^https?:\/\//i.test(url)) url = 'https://' + url
                    window.open(url, '_blank', 'noopener,noreferrer')
                  }}
                />
              )}
              <Button
                label="Close"
                redOutlined
                className="min-w-[160px] px-10"
                onClick={() => setSelectedAct(null)}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default ActsAndRules
